var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"mobile-footer"},[_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }